function mergeDeep(a, b) {
  const A = a && typeof a === "object" ? a : {};
  const B = b && typeof b === "object" ? b : {};
  const out = { ...A };
  for (const k of Object.keys(B)) {
    const av = out[k];
    const bv = B[k];
    if (av && typeof av === "object" && !Array.isArray(av) && bv && typeof bv === "object" && !Array.isArray(bv)) {
      out[k] = mergeDeep(av, bv);
    } else {
      out[k] = bv;
    }
  }
  return out;
}

function ensureGraph(cfg) {
  const c = cfg && typeof cfg === "object" ? cfg : {};
  const g = c.graph && typeof c.graph === "object" ? c.graph : null;
  if (g && Array.isArray(g.nodes) && Array.isArray(g.edges)) return c;
  return {
    ...c,
    graph: {
      nodes: [
        { key: "start", type: "Start", position: { x: 0, y: 0 }, config: { label: "Início" } },
        { key: "end", type: "End", position: { x: 420, y: 0 }, config: { label: "Fim" } },
      ],
      edges: [{ from: "start", to: "end", condition: { always: true } }],
    },
  };
}

export const CAMPAIGN_TEMPLATES = [
  {
    id: "funnel_full_generic",
    label: "Funil completo (padrão)",
    description: "Estrutura completa do funil com etapas para configurar.",
    kind: "funnel",
    recommended: true,
    defaultUxFunnel: {
      stages: {
        acquisition: { mode: "simple" },
        capture: { mode: "simple" },
        entry: { mode: "simple" },
        activation: { mode: "simple" },
        conversion: { mode: "simple" },
        expansion: { mode: "simple" },
        retention: { mode: "simple" },
        recovery: { mode: "simple" },
      },
    },
    applyToFlowConfig(existingConfig) {
      const base = ensureGraph(existingConfig);
      return mergeDeep(base, { uxFunnel: this.defaultUxFunnel });
    },
  },
  {
    id: "ig_comment_to_dm_sales",
    label: "Instagram: comentário → DM (vendas)",
    description: "Identifica comentários (post/palavra-chave) e envia DM automaticamente.",
    kind: "automation",
    recommended: true,
    // backend já conhece este templateKey (já estava no wizard anterior)
    templateKey: "instagram_comment_to_dm_sales",
    defaultUxFunnel: {
      stages: {
        acquisition: { mode: "simple", channel: "instagram" },
        capture: { mode: "simple", channel: "instagram", notes: "Captura via comentário em post específico / keyword." },
        activation: { mode: "simple", channel: "instagram", notes: "Resposta automática por DM." },
        conversion: { mode: "simple", channel: "instagram" },
        recovery: { mode: "simple", channel: "instagram" },
      },
    },
    // Não forçamos trigger aqui (pode variar), mas garantimos uxFunnel e um grafo mínimo.
    applyToFlowConfig(existingConfig) {
      const base = ensureGraph(existingConfig);
      return mergeDeep(base, { uxFunnel: this.defaultUxFunnel });
    },
  },
  {
    id: "whatsapp_one_shot_message",
    label: "WhatsApp: disparo simples (1 mensagem)",
    description: "Uma automação simples para enviar uma mensagem (configurar destinatário/regra no avançado).",
    kind: "automation",
    recommended: false,
    defaultUxFunnel: {
      stages: {
        activation: { mode: "simple", channel: "whatsapp", notes: "Disparo simples. Ajuste gatilho e destinatário no modo avançado." },
        recovery: { mode: "simple", channel: "whatsapp" },
      },
    },
    applyToFlowConfig(existingConfig) {
      const base = ensureGraph(existingConfig);
      return mergeDeep(base, { uxFunnel: this.defaultUxFunnel });
    },
  },
  {
    id: "email_one_shot",
    label: "Email: disparo simples (1 email)",
    description: "Campanha simples para envio de email (gatilho e integração dependem do workspace).",
    kind: "automation",
    recommended: false,
    defaultUxFunnel: {
      stages: {
        activation: { mode: "simple", channel: "email", notes: "Disparo simples. Selecione integração e configure envio no modo avançado." },
        recovery: { mode: "simple", channel: "email" },
      },
    },
    applyToFlowConfig(existingConfig) {
      const base = ensureGraph(existingConfig);
      return mergeDeep(base, { uxFunnel: this.defaultUxFunnel });
    },
  },
];

export function getTemplateById(id) {
  return CAMPAIGN_TEMPLATES.find((t) => t.id === id) || CAMPAIGN_TEMPLATES[0];
}

